import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'json-area',
    templateUrl: './json-area.component.html',
    styleUrls: ['./json-area.component.scss'],
    standalone: false
})
export class JsonAreaComponent implements OnInit {

  @Input() value: any;
  @Input() rows = 5;
  isJSONValid = true;

  constructor() {
  }

  get convertedValue() {
    return JSON.stringify(this.value, null, '  ');
  }

  set convertedValue(v: string) {
    try {
      const parsedJSON = JSON.parse(v);
      Object.keys(this.value).forEach(key => {
        delete this.value[key];
      });
      _.merge(this.value, parsedJSON);
      this.isJSONValid = true;
    } catch (e) {
      this.isJSONValid = false;
      console.log(e);
    }
  }

  ngOnInit() {
  }

}
